module.exports = __webpack_public_path__ + "static/media/transporter-2.87e932b2.svg";